import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-controle-pesos-altura',
  templateUrl: './dialog-controle-pesos-altura.component.html',
  styleUrls: ['./dialog-controle-pesos-altura.component.css']
})
export class DialogControlePesosAlturaComponent {
  public altura: string;

  public constructor(
    @Inject(MAT_DIALOG_DATA) data: { altura?: number },
    private dialogRef: MatDialogRef<DialogControlePesosAlturaComponent>
  ) {
    this.altura = data.altura ? data.altura.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) : '';
  }

  public aoDigitar(): void {
    const valor = this.altura.replace(/[^0-9,.]/g, '');
    const separador = valor.search(/[,.]/);

    this.altura = separador < 0 ? valor : `${valor.substring(0, separador + 1)}${valor.substring(separador + 1).replace(/[,.]/g, '')}`;
  }

  public salvar(): void {
    const altura = Number(this.altura.replace(',', '.'));

    if (altura >= .5 && altura <= 3) {
      this.dialogRef.close(altura);
    }
  }

  public get alturaValida(): boolean {
    const altura = Number(this.altura.replace(',', '.'));
    return altura >= .5 && altura <= 3;
  }
}
